import React from "react";
import MuiAppBar, { type AppBarProps } from "@mui/material/AppBar";
import MuiToolbar, { type ToolbarProps } from "@mui/material/Toolbar";
import MuiButton, { type ButtonProps } from "@mui/material/Button";

export type { AppBarProps, ToolbarProps };

export function AppBar(props: AppBarProps) {
  return <MuiAppBar {...props} />;
}

export function Toolbar(props: ToolbarProps) {
  return <MuiToolbar {...props} />;
}

export interface AppBarNavItemProps extends Omit<ButtonProps, "children" | "variant"> {
  label: string;
  icon?: React.ReactNode;
  selected?: boolean;
  href?: string;
}

export function AppBarNavItem({
  label,
  icon,
  selected = false,
  href,
  sx,
  ...props
}: AppBarNavItemProps) {
  return (
    <MuiButton
      variant="text"
      href={href}
      startIcon={icon}
      disableElevation
      {...props}
      sx={[
        {
          height: 32,
          padding: "6px 12px",
          fontSize: 14,
          fontWeight: 500,
          color: "action.active",
          textTransform: "none",
          boxShadow: "none",
          "&:hover": {
            backgroundColor: "action.hover",
            color: "text.primary",
            boxShadow: "none",
          },
          "&:focus-visible": {
            boxShadow: "none",
          },
          "& .MuiButton-startIcon": {
            marginRight: 0.5,
          },
        },
        selected && {
          color: "primary.light",
          fontWeight: 600,
          "&:hover": {
            backgroundColor: "action.selected",
            color: "primary.light",
            boxShadow: "none",
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {label}
    </MuiButton>
  );
}
